module.exports = __webpack_public_path__ + "img/0Q3A5801_FoamcoreMatted.4459e62a.jpg";